import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    RoleCheckDirective, HasOnePermissionDirective,
    HasAllPermissionsDirective, ExceptPermissionsDirective,
    ExceptRolesDirective
} from './directives/permissions/index';
import { AuthenticationService, UsersService, OptionService, RoleService, User_alarmService } from './services/index';

import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import {
    MatButtonModule, MatTooltipModule, MatIconModule,
    MatFormFieldModule, MatCheckboxModule, MatInputModule,
    MatSelectModule, MatDatepickerModule, MatNativeDateModule,
    MatTableModule, MatSortModule, MatPaginatorModule, MatRadioModule,
    MatChipsModule, MatAutocompleteModule,
} from '@angular/material';
import { DataTableModule, SharedModule } from 'primeng/primeng';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { NgxEditorModule } from 'ngx-editor';
import { AgmCoreModule } from '@agm/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ChartsModule } from 'ng2-charts';
import { ModalModule, TimepickerModule, BsDatepickerModule } from 'ngx-bootstrap';
import { ScrollDispatchModule } from '@angular/cdk/scrolling';
@NgModule({
    imports: [
        CommonModule,

        FormsModule,
        ReactiveFormsModule,

        MatAutocompleteModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatTooltipModule,
        MatIconModule,
        MatRadioModule,
        MatChipsModule,
        ScrollDispatchModule,

        DataTableModule,
        DialogModule,
        TooltipModule,

        ChartsModule,

        ModalModule.forRoot(),
        TimepickerModule,
        BsDatepickerModule.forRoot(),

        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBJE_0RWVmU8nLpkx20PxzIhaxowPuAl9c'
        }),
        TranslateModule,

        NgxMatSelectSearchModule,
        NgxEditorModule,

        LoadingModule.forRoot({
            animationType: ANIMATION_TYPES.wanderingCubes,
            backdropBackgroundColour: 'rgba(0,0,0,0.1)',
            backdropBorderRadius: '4px',
            primaryColour: '#000000',
            secondaryColour: '#ffffff',
            tertiaryColour: '#ffffff'
        })],
    declarations: [
        RoleCheckDirective,
        HasOnePermissionDirective,
        HasAllPermissionsDirective,
        ExceptPermissionsDirective,
        ExceptRolesDirective,

    ],
    exports: [
        RoleCheckDirective,
        HasOnePermissionDirective,
        HasAllPermissionsDirective,
        ExceptPermissionsDirective,
        ExceptRolesDirective,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormsModule,
        ReactiveFormsModule,

        MatAutocompleteModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatTooltipModule,
        MatIconModule,
        MatRadioModule,
        MatChipsModule,
        ScrollDispatchModule,

        ChartsModule,

        ModalModule,
        TimepickerModule,
        BsDatepickerModule,

        NgxMatSelectSearchModule,
        NgxEditorModule,

        DataTableModule,
        DialogModule,
        TooltipModule,

        LoadingModule,

        AgmCoreModule,

        TranslateModule,
    ],
    providers: [
        AuthenticationService,
        UsersService,
        OptionService,
        RoleService,
        User_alarmService

    ]
})
export class SharedCustomModule { }



// WEBPACK FOOTER //
// /var/www/hqsol/hqsol-live/app/src/app/shared.module.ts